"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _acsReportsSdk = require("@adsk/acs-reports-sdk");
var _getRequestConfig = _interopRequireDefault(require("../../../helpers/getRequestConfig"));
var _constants = require("../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const POLLING_INTERVAL_IN_MS = 5000;
const REPORT_STATUSES = {
  COMPLETE: 'complete',
  ERROR: 'error',
  PENDING: 'pending'
};
const usePollUntilReportCompletion = _ref => {
  let {
    isOpen,
    reportId,
    accountId,
    projectId,
    setActivePageName,
    setReportUrl,
    setReportId,
    successNotification,
    errorNotification,
    onReportComplete = () => {}
  } = _ref;
  (0, _react.useEffect)(() => {
    const controller = new AbortController();
    if (reportId) {
      const requestConfig = (0, _getRequestConfig.default)();
      (0, _acsReportsSdk.pollReport)({
        id: reportId,
        ...(accountId ? {
          accountId
        } : {
          projectId
        }),
        skipNotificationsOnComplete: isOpen,
        interval: POLLING_INTERVAL_IN_MS,
        signal: controller.signal
      }, requestConfig).then(report => {
        const {
          status,
          url
        } = report;
        onReportComplete(report);
        if (status === REPORT_STATUSES.COMPLETE) {
          successNotification();
          setReportUrl(url);
          setActivePageName(_constants.PAGES.SUCCESS);
        } else if (status === REPORT_STATUSES.ERROR) {
          errorNotification();
          setActivePageName(_constants.PAGES.FORM);
        }
        setReportId(null);
      }).catch(() => {
        errorNotification();
        setActivePageName(_constants.PAGES.FORM);
        setReportId(null);
      });
    }
    return () => controller.abort();
  }, [reportId]);
};
var _default = exports.default = usePollUntilReportCompletion;